import { CPsCellRenderer } from "../../../../../shared/components/CustomCells/CPsCellRenderer";
import { ColumnsFactory} from "../../../../../shared/components/Grid/functions";
import './styles.css';



const ColumnsExpatriados = (translate) =>[
  ColumnsFactory.DateColumn(translate("expatriado-desde"), "fechaExpatriadoDesde"),
  ColumnsFactory.DateColumn(translate("expatriado-hasta"), "fechaExpatriadoHasta"),
  ColumnsFactory.DateColumn(translate("facturacion-inicial"), "fechaFacturacionExpatriadoInicial"),
  ColumnsFactory.DateColumn(translate("facturacion-final"), "fechaFacturacionExpatriadoFinal"),
  ColumnsFactory.TextColumn(translate("empresa"), "empresaExpatriadoNombre"),
  ColumnsFactory.TextColumn(translate("centro-costo-destino"), "centroCostoDestinoExpatriado"),
  ColumnsFactory.TextColumn(translate("grupoFactura"), "grupoFacturaExpatriado"),
]

const viewCPs = (currentUser)=> currentUser && (currentUser.administraExpatriados === true || 
  currentUser.administraExpatriadosLocal === true || currentUser.consultaExpatriados === true) ? null 
  : {cellRendererFramework:CPsCellRenderer};


export const getColumnDefs = (translate,currentUser) => {

  return [
    ColumnsFactory.TextColumn(translate('dni'), "dni",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('usuario'), "login",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('nombre'), "nombre",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('dn-sg-id'), "idDN"),
    ColumnsFactory.TextColumn(translate('dn-sg'), "direccionNegocio"),
    ColumnsFactory.TextColumn(translate('area'), "area"),
    ColumnsFactory.TextColumn(translate('centro-produccion'), "idCP",viewCPs(currentUser)),
    ColumnsFactory.TextColumn(translate('perfil'), "nombrePerfil"),
    ColumnsFactory.TextColumn(translate("rol"), 'rol'),
    ColumnsFactory.TextColumn(translate('tipo'), "tipo", {floatingFilterComponent: 'TipoUsuarioFilter',floatingFilterComponentParams: {suppressFilterButton: true}}),
    ColumnsFactory.TextColumn(translate('provincia-cotizacion'), "provincia"),
    ColumnsFactory.TextColumn(translate('sociedad-original'), "sociedadOriginal"),
    ColumnsFactory.TextColumn("Email", "email"),
    ColumnsFactory.DateColumn(translate('fecha-baja'), "fechaBaja"),
    ColumnsFactory.TextColumn(translate('responsable'), "nombreResponsable"),
    ColumnsFactory.GroupColumn(translate('datos-expatriacion'), ColumnsExpatriados(translate), 'header-group-expatriados-grid'),
    ColumnsFactory.BooleanColumn(translate('partes-con-obra'), "partesConObra"),
    ColumnsFactory.BooleanColumn(translate('administra-usuarios'), "administraUsuarios"),
    ColumnsFactory.BooleanColumn(translate('usuarios-delegados'), "tieneDelegados"),
    ColumnsFactory.BooleanColumn(translate('control-usuarios'), "controlUsuarios")
  ];
};